import request from '@/utils/request_cn';

// 价格——买手店
export async function getVendorsByVendorName() {
  return (await request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller/regionFilter`,
    method: 'post',
    data: {
      needChildVendorFlag: false,
    },
  })).data;
}
///pageEmailSendRecord
export async function pageEmailSendRecord(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/email/pageEmailSendRecord`,
    method: "post",
    data
  })).data;
}
//batchRetryEmail
export async function batchRetryEmail(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/email/batchRetryEmail`,
    method: "post",
    data
  })).data;
}